<article>
  <h1>Battery</h1>
  Future use
</article>
